/** A compact, single-line JSON summary for a decoded frame — `null`/`undefined` render as nothing. */
export function formatDecoded(decoded: unknown): string | null {
  if (decoded === null || decoded === undefined) return null;
  try {
    return JSON.stringify(decoded, (_, value) =>
      typeof value === 'bigint' ? value.toString() : value
    );
  } catch {
    return null;
  }
}
